<template>
  <div class="racontrols">
    <StudyFullscreenSwitcher
      v-if="hasFullscreen"
      data-tst="study_fullscreen"
      :toggleKey="`sw_study_${$store.getters.sw_tabs_study}_fullscreen`"
      :hotkeyActive="true"
    />
    <StudyGroupingSwitcherNew />
    <StudyLayoutSwitcher v-if="hasLayoutSwitch" />
  </div>
</template>

<script>
import StudyFullscreenSwitcher from '@/components/Study/Switchers/StudyFullscreenSwitcher'
import StudyGroupingSwitcherNew from '@/components/Switchers/StudyGroupingSwitcherNew'
import StudyLayoutSwitcher from '@/components/Switchers/StudyLayoutSwitcher'

export default {
  name: 'StudyControlsMain',
  components: {
    StudyFullscreenSwitcher,
    StudyGroupingSwitcherNew,
    StudyLayoutSwitcher,
  },
  props: {
    hasFullscreen: { type: Boolean, default: true },
    hasLayoutSwitch: { type: Boolean, default: true },
  },
}
</script>
<style lang="scss" scoped>
.racontrols {
  display: flex;
  gap: 0.25rem;
  padding: 0 0.25rem;
  background: var(--clr-black-1);
  border-radius: 6px;
  align-items: center;
  justify-content: center;
  max-height: 1.65rem;
}
</style>
